// Ensure loadScript exists (only define if not already present)
if (!window.loadScript) {
  window.loadScript = function (src) {
    return new Promise((resolve, reject) => {
      const s = document.createElement('script');
      s.src = src;
      s.onload = () => resolve();
      s.onerror = () => reject(new Error('Failed to load ' + src));
      document.body.appendChild(s);
    });
  };
}

// Define cart-drawer only once
if (!customElements.get('cart-drawer')) {
  class CartDrawer extends SideDrawer {
    constructor() {
      super();
      this.cartSummary = this.querySelector('.cart-drawer__summary');
      this.init();
      this.bindEvents();
    }

    init() {
      const cartIcon = document.getElementById('cart-icon');
      if (!cartIcon) return;
      cartIcon.setAttribute('role', 'button');
      cartIcon.addEventListener('click', () => this.open(cartIcon));
    }

    bindEvents() {
      // keep bound handlers so removeEventListener works
      this.refreshHandler = this.refresh.bind(this);
      document.addEventListener('dispatch:cart-drawer:refresh', this.refreshHandler);

      this.openHandler = (evt) => this.open(evt?.detail?.opener);
      document.addEventListener('dispatch:cart-drawer:open', this.openHandler);
    }

    /**
     * Returns an array of sections to render.
     * Adjust ids/section names to match your theme's sections if different.
     */
    getSectionsToRender() {
      return [
        {
          id: 'cart-drawer',
          section: this.closest('.shopify-section')?.id?.replace('shopify-section-', '') || 'cart-drawer',
          selector: 'cart-drawer'
        },
        {
          id: 'cart-icon-bubble',
          section: 'cart-icon-bubble',
          selector: '.shopify-section'
        }
      ];
    }

    /**
     * Refresh the drawer (calls cart-items.refresh() if present, or fetches whole sections)
     */
    async refresh(dontRefreshCartItems = false) {
      try {
        const cartItems = this.querySelector('cart-items');
        if (cartItems && !dontRefreshCartItems && typeof cartItems.refresh === 'function') {
          cartItems.refresh();
        } else {
          const sections = this.getSectionsToRender().map(s => s.section);
          // FIXED: use template literal correctly
          const res = await fetch(`?sections=${sections.join(',')}`);
          const json = await res.json();
          this.renderContents({ sections: json }, false);
        }
      } catch (err) {
        console.error('CartDrawer.refresh error:', err);
      }
    }

    /**
     * Render sections into DOM and optionally open drawer
     */
    async renderContents(data, openDrawer = true) {
      try {
        if (!this.scriptsLoaded) {
          // theme.scripts.* must exist in your theme; guard if not present
          if (window.theme && theme.scripts && theme.scripts.cartItems) {
            await loadScript(theme.scripts.cartItems);
          }
          if (this.dataset.shippingCalculator && window.theme && theme.scripts && theme.scripts.shippingCalculator) {
            await loadScript(theme.scripts.countryProvinceSelector);
            await loadScript(theme.scripts.shippingCalculator);
          }
          this.scriptsLoaded = true;
        }

        this.getSectionsToRender().forEach(({ id, section, selector }) => {
          const el = document.getElementById(id);
          if (el && data && data.sections && data.sections[section]) {
            try {
              el.innerHTML = CartDrawer.getElementHTML(data.sections[section], selector);
            } catch (err) {
              // fallback: assign raw HTML if parsing fails
              el.innerHTML = data.sections[section];
              console.warn('CartDrawer: getElementHTML failed for', section, err);
            }
          }
        });

        if (openDrawer && this.getAttribute('open') == null) {
          this.open();
        }
      } catch (err) {
        console.error('CartDrawer.renderContents error:', err);
      }
    }

    static getElementHTML(html, selector) {
      const tmp = document.createElement('template');
      tmp.innerHTML = html;
      const node = tmp.content.querySelector(selector);
      if (!node) {
        throw new Error('Selector not found in provided HTML: ' + selector);
      }
      return node.innerHTML;
    }

    static recalculateCssVarHeights() {
      requestAnimationFrame(() => {
        document.dispatchEvent(new CustomEvent('on:css-var-height:update'));
      });
    }
  }

  customElements.define('cart-drawer', CartDrawer);
}